import axios from 'axios';
import qs from 'qs';

const API_Url = 'http://w-s/';

export default {
  actions: {
    // Авторизация

    AdminAuthAct({commit}, [AdminLogin, AdminPass]) {
      let data = {
        'admin_login': AdminLogin,
        'admin_pass': AdminPass
      };
      const options = {
        method: 'POST',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify(data),
        url: API_Url + 'docs/admin.auth'
      };
      axios(options)
        .then(res => {
          const AdminID = res.data.response.admin_id;
          const AdminToken = res.data.response.admin_token;
          commit('AdminAuthMut', {AdminID, AdminToken});
        })
        .catch(error => {
          if (error.response) {
            const Error = error.response.data.error;
            commit('AdminAuthErrorMut', Error);
          }
        });
    },


    // Выход

    AdminExitAct({commit}) {
      commit('AdminExitMut')
    },
  },
  mutations: {
    AdminAuthMut(state, {AdminID, AdminToken}) {
      state.AdminAuth.Error = [];
      state.AdminAuth.AuthRes.AdminAuthStatus = true;
      state.AdminAuth.AuthRes.AdminID = AdminID;
      state.AdminAuth.AuthRes.AdminToken = AdminToken;
    },

    AdminExitMut(state) {
      state.AdminAuth.AuthRes.AdminAuthStatus = false;
      state.AdminAuth.AuthRes.AdminID = null;
      state.AdminAuth.AuthRes.AdminToken = null;
      state.AdminAuth.Error = [];
    },

    AdminAuthErrorMut(state, AuthError) {
      state.AdminAuth.AuthError = AuthError;
    },
  },
  state: {
    AdminAuth: {
      Error: [],
      AuthRes: {
        AdminAuthStatus: false,
        AdminID: null,
        AdminToken: null,
      }
    },
  },
  getters: {
    /**
     * @return {boolean}
     */
    AdminAuthStatusGet(state) {
      return state.AdminAuth.AuthRes.AdminAuthStatus;
    },

    AdminAuthErrorGet(state) {
      return state.AdminAuth.AuthError;
    },

    AdminAuthInfoGet(state) {
      return state.AdminAuth.AuthRes;
    },
  }
}
